/**
 * Metal Type + Ring/Seal Color chips (Internal San Jose / Ryan).
 * Same two-line chip language as seal size; drives stock Thinkspace controls.
 */
(function () {
  'use strict';

  var METAL_OPTION = 'Metal Type';
  var METAL_READY = 'data-sj-metal-chips-ready';
  var COLOR_READY = 'data-sj-color-chips-ready';

  var METAL_COPY = {
    '10K': { title: '10K Gold', subtitle: 'Lightweight & Durable' },
    '14K': { title: '14K Gold', subtitle: 'Rich & Luxurious' },
    'Platinum Silver': {
      title: 'Platinum Silver',
      subtitle: 'Bright & Tarnish-Resistant',
    },
    'PL Silver': {
      title: 'Platinum Silver',
      subtitle: 'Bright & Tarnish-Resistant',
    },
  };

  function metalCopy(value, text) {
    var raw = String(value || '').trim();
    var label = String(text || '').trim();
    if (METAL_COPY[raw]) return METAL_COPY[raw];
    if (/platinum\s*silver/i.test(raw) || /platinum\s*silver/i.test(label)) {
      return METAL_COPY['Platinum Silver'];
    }
    if (/^10\s*k/i.test(raw) || /^10\s*k/i.test(label)) return METAL_COPY['10K'];
    if (/^14\s*k/i.test(raw) || /^14\s*k/i.test(label)) return METAL_COPY['14K'];
    return {
      title: raw || label || 'Metal',
      subtitle: label && label !== raw ? label : '',
    };
  }

  function cfg() {
    return window.__SJ_IMAGE_STEPPER_CONFIG__ || {};
  }

  function metalSwatchMap() {
    var m = cfg().metalSwatches;
    return m && typeof m === 'object' ? m : {};
  }

  function colorKey(value, label) {
    var v = String(value || '').toLowerCase();
    var t = String(label || '').trim();
    if (v === 'yellow' || /yellow/i.test(t)) return 'yellow';
    if (v === 'rose' || /rose/i.test(t)) return 'rose';
    if (v === 'pl-silver' || /pl\s*silver|platinum/i.test(t)) return 'pl-silver';
    if (v === 'white' || /white/i.test(t)) return 'white';
    return v || '';
  }

  function colorTitle(value, label) {
    var key = colorKey(value, label);
    if (key === 'yellow') return 'Yellow';
    if (key === 'white') return 'White';
    if (key === 'rose') return 'Rose';
    if (key === 'pl-silver') return 'Platinum Silver';
    return String(label || value || 'Color').trim();
  }

  function ringKaratLabel() {
    var metal = currentMetalValue();
    if (/platinum\s*silver/i.test(metal)) return '';
    if (/^14\s*k/i.test(metal)) return '14K';
    if (/^10\s*k/i.test(metal)) return '10K';
    return '';
  }

  function goldColorName(key) {
    if (key === 'yellow') return 'Yellow Gold';
    if (key === 'rose') return 'Rose Gold';
    if (key === 'white') return 'White Gold';
    return '';
  }

  /**
   * Compact panel summary + per-swatch labels.
   * Always write out karat + color (capital K): "10K Yellow Gold", "14K White Gold".
   * Under Platinum Silver metal, seal `pl-silver` is included "Platinum Silver";
   * seal `white` is the paid "14K White Gold" upgrade (must stay distinct).
   */
  function colorSummaryText(kind, value, label) {
    var key = colorKey(value, label);

    if (kind === 'ring' || kind === 'pendant') {
      if (isPlatinumSilverMetal()) return 'Platinum Silver';
      var karat = ringKaratLabel();
      var gold = goldColorName(key);
      if (karat && gold) return karat + ' ' + gold;
      return [karat, colorTitle(value, label)].filter(Boolean).join(' ');
    }

    if (kind === 'seal' || kind === 'logo') {
      // Included PS seal — distinct from paid white gold
      if (key === 'pl-silver') return 'Platinum Silver';
      if (key === 'white') return '14K White';
      if (key === 'yellow') return '14K Yellow';
      if (key === 'rose') return '14K Rose';
      return colorTitle(value, label);
    }

    return colorTitle(value, label);
  }

  function swatchUrlFor(value, label) {
    var map = metalSwatchMap();
    var key = colorKey(value, label);
    return (key && map[key]) || '';
  }

  function setSelectValue(select, value) {
    var B = window.Sj3dBuilder;
    if (B && typeof B.setSelectValue === 'function') {
      B.setSelectValue(select, value);
      return;
    }
    if (!select) return;
    if (select.value !== value) select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    select.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function optionListSignature(items) {
    var parts = [];
    for (var i = 0; i < items.length; i++) {
      parts.push(
        String(items[i].value || '') +
          ':' +
          (items[i].disabled ? '1' : '0')
      );
    }
    return parts.join('|');
  }

  function ensureMount(field, attr) {
    var mount = field.querySelector('[' + attr + ']');
    if (!mount) {
      mount = document.createElement('div');
      mount.setAttribute(attr, '');
      field.appendChild(mount);
    }
    return mount;
  }

  function renderMetalChips(field) {
    var select = field.querySelector('select');
    if (!select) return;

    var mount = ensureMount(field, 'data-sj-metal-chips');
    var current = String(select.value || '');
    var opts = Array.from(select.options || []).filter(function (opt) {
      return !opt.disabled && String(opt.value || '').trim() !== '';
    });
    if (!opts.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'sj-option-chips sj-metal-chips';
    wrap.setAttribute('data-sj-sig', optionListSignature(opts));
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Metal Type');

    opts.forEach(function (opt) {
      var value = String(opt.value).trim();
      var copy = metalCopy(value, opt.textContent);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sj-option-chip';
      if (/^14\s*k/i.test(value) || copy.title === '14K Gold') {
        btn.classList.add('sj-option-chip--14k');
      }
      btn.classList.toggle('is-selected', value === current);
      btn.setAttribute('aria-pressed', value === current ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        copy.subtitle ? copy.title + ', ' + copy.subtitle : copy.title
      );
      btn.innerHTML =
        '<span class="sj-option-chip__text">' +
        '<span class="sj-option-chip__title">' +
        copy.title +
        '</span>' +
        (copy.subtitle
          ? '<span class="sj-option-chip__subtitle">' + copy.subtitle + '</span>'
          : '') +
        '</span>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setSelectValue(select, value);
        window.setTimeout(function () {
          refreshMetalChips(field);
          document.querySelectorAll('.sj-color-chips-host').forEach(function (colorField) {
            refreshColorChips(colorField, true);
          });
        }, 0);
      });
      wrap.appendChild(btn);
    });

    mount.innerHTML = '';
    mount.appendChild(wrap);
    field.classList.add('sj-metal-chips-host');
  }

  function refreshMetalChips(field, force) {
    var select = field.querySelector('select');
    if (!select) return;
    var opts = Array.from(select.options || []).filter(function (opt) {
      return !opt.disabled && String(opt.value || '').trim() !== '';
    });
    var mount = field.querySelector('[data-sj-metal-chips]');
    var wrap = mount && mount.querySelector('.sj-metal-chips');
    var buttons = wrap && wrap.querySelectorAll('.sj-option-chip');
    var sig = optionListSignature(opts);
    if (
      !force &&
      wrap &&
      buttons &&
      wrap.getAttribute('data-sj-sig') === sig &&
      buttons.length === opts.length
    ) {
      var current = String(select.value || '');
      for (var i = 0; i < buttons.length; i++) {
        var on = String(opts[i].value).trim() === current;
        buttons[i].classList.toggle('is-selected', on);
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      return;
    }
    renderMetalChips(field);
  }

  function enhanceMetalField(field) {
    if (!field || field.getAttribute(METAL_READY) === '1') return;
    var select = field.querySelector('select');
    if (!select) return;

    field.setAttribute(METAL_READY, '1');
    renderMetalChips(field);

    var refresh = (window.Sj3dBuilder && window.Sj3dBuilder.rafDebounce
      ? window.Sj3dBuilder.rafDebounce
      : function (fn) { return fn; })(function () {
      refreshMetalChips(field);
    });
    var mo = new MutationObserver(refresh);
    mo.observe(select, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'selected', 'disabled'],
    });
    select.addEventListener('change', refresh);
    field._sjMetalMo = mo;
  }

  function findColorInputs(field) {
    // Prefer radios that are NOT inside our chip mount
    return Array.from(field.querySelectorAll('input[type="radio"]')).filter(
      function (input) {
        return !input.closest('[data-sj-color-chips]');
      }
    );
  }

  function swatchHexForInput(input) {
    var root = input.closest('label') || input.parentElement || input;
    var swatch =
      (root.querySelector && root.querySelector('[data-swatch-bg]')) ||
      swatchNear(input);
    if (!swatch) return '#ccc';
    var bg = (swatch.style && swatch.style.backgroundColor) || '';
    if (!bg) {
      try {
        bg = window.getComputedStyle(swatch).backgroundColor || '';
      } catch (_) {
        bg = '';
      }
    }
    return bg || '#ccc';
  }

  function swatchNear(input) {
    var sib = input.nextElementSibling;
    while (sib) {
      if (sib.matches && sib.matches('[data-swatch-bg]')) return sib;
      var nested = sib.querySelector && sib.querySelector('[data-swatch-bg]');
      if (nested) return nested;
      sib = sib.nextElementSibling;
    }
    var parent = input.parentElement;
    return parent ? parent.querySelector('[data-swatch-bg]') : null;
  }

  function formatPricePlus(raw) {
    var n = Number(raw);
    if (!Number.isFinite(n) || n <= 0) return '';
    return '+$' + (n % 1 === 0 ? String(Math.round(n)) : n.toFixed(2));
  }

  function normalizePriceHint(text) {
    var m = String(text || '').match(/\+\s*\$?\s*([\d,]+(?:\.\d{2})?)/);
    if (!m) return '';
    return formatPricePlus(String(m[1]).replace(/,/g, ''));
  }

  /** Seal-color surcharge from Thinkspace addons_pricing (authoritative). */
  function sealColorPriceFromData(colorValue) {
    var value = String(colorValue || '').trim();
    if (!value) return '';
    // Matching PS seal is included — never a seal-color surcharge
    if (value === 'pl-silver') return '';
    // Pendant tops have no band. The $200 seal fee is the ring/band offset,
    // so a pendant does not show it. The total is adjusted in the widget.
    var widgetFor =
      window.__SJ_IMAGE_STEPPER_CONFIG__ &&
      window.__SJ_IMAGE_STEPPER_CONFIG__.widgetFor;
    if (widgetFor === 'pendant') return '';
    try {
      var B = window.Sj3dBuilder;
      var w = (B && B.controller && B.controller()) || window.w || null;
      var data = B && typeof B.catalogData === 'function' ? B.catalogData() : null;
      if (!data) {
        var script = document.querySelector(
          'x-3d-product-options script[data-prop="data"]'
        );
        data = script ? JSON.parse(script.textContent || '{}') : null;
      }
      var tables =
        data &&
        data.addons_pricing &&
        data.addons_pricing.seal_color_additional_price;
      if (!tables) return '';
      var metalStone = w && w.metal_stone;
      var metal = w && w.metal;
      var row =
        (metalStone && tables[metalStone]) ||
        (metal && tables[metal]) ||
        null;
      if (!row) return '';
      return formatPricePlus(row[value]);
    } catch (_) {
      return '';
    }
  }

  function priceHintForInput(input, kind) {
    if (!input) return '';
    var value = String(input.value || '').trim();
    // Two-tone +$275 already covers a 14K logo in any color.
    // Do not show (or scrape) a seal-color surcharge on Logo Color.
    if (kind === 'logo') return '';
    // Included Platinum Silver seal — do not show a plus (and don't scrape siblings)
    if (kind === 'seal' && value === 'pl-silver') {
      return '';
    }
    if (kind === 'seal') {
      var fromData = sealColorPriceFromData(value);
      if (fromData) return fromData;
    }
    // Only the option's own label — parent textContent includes other swatches' +$
    var host = input.closest('label') || input.parentElement;
    if (!host) return '';
    return normalizePriceHint(host.textContent);
  }

  function currentMetalValue() {
    var select = document.querySelector(
      '[data-option="' + METAL_OPTION + '"] select'
    );
    return select ? String(select.value || '').trim() : '';
  }

  function isPlatinumSilverMetal() {
    return /platinum\s*silver/i.test(currentMetalValue());
  }

  function colorFieldKind(field) {
    var name = field.getAttribute('data-option') || '';
    if (name === 'Seal Color') return 'seal';
    if (name === 'Logo Color') return 'logo';
    if (/Ring Color/i.test(name)) return 'ring';
    if (/Pendant Color/i.test(name)) return 'pendant';
    return 'color';
  }

  function colorPanelTitle(kind) {
    if (kind === 'seal') return 'Seal Color';
    if (kind === 'logo') return 'Logo Color';
    if (kind === 'pendant') return 'Pendant Color';
    if (kind === 'ring') return 'Ring Color';
    return 'Color';
  }

  /** Seal/Logo metal is always 14K unless shopper picked Platinum Silver. */
  function karatBadgeForKind(kind) {
    if (kind === 'seal' || kind === 'logo') {
      return isPlatinumSilverMetal() ? '' : '14K';
    }
    if (kind === 'ring' || kind === 'pendant') {
      return ringKaratLabel();
    }
    return '';
  }

  function rawLabelForInput(input) {
    var host = input.closest('label') || input.parentElement;
    var srOnly =
      host && host.querySelector('.tw\\:sr-only, .sr-only, [class*="sr-only"]');
    return (
      (srOnly && srOnly.textContent) ||
      input.getAttribute('aria-label') ||
      input.value ||
      ''
    );
  }

  function selectedColorSummary(kind, inputs) {
    for (var i = 0; i < inputs.length; i++) {
      if (!inputs[i].checked) continue;
      var name = colorSummaryText(
        kind,
        inputs[i].value,
        rawLabelForInput(inputs[i])
      );
      // Show surcharge on the top label (e.g. "14K White Gold +$200")
      var price = priceHintForInput(inputs[i], kind);
      if (price && kind === 'seal') {
        return name + ' ' + price;
      }
      return name;
    }
    return '';
  }

  function renderColorChips(field) {
    var inputs = findColorInputs(field);
    if (!inputs.length) return;

    var kind = colorFieldKind(field);
    var title = colorPanelTitle(kind);
    var badge = karatBadgeForKind(kind);
    var summary = selectedColorSummary(kind, inputs);
    var mount = ensureMount(field, 'data-sj-color-chips');
    var compact =
      kind === 'ring' ||
      kind === 'pendant' ||
      kind === 'seal' ||
      kind === 'logo';
    var logoRow = kind === 'logo';

    var panel = document.createElement('div');
    panel.className =
      'sj-color-panel sj-color-panel--' +
      kind +
      (compact ? ' sj-color-panel--compact' : '');
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', title);

    var head = document.createElement('div');
    head.className = 'sj-color-panel__head';

    if (compact) {
      // e.g. "Ring Color: 10K Yellow Gold" / "Seal Color: Platinum Silver"
      head.innerHTML =
        '<span class="sj-color-panel__title">' +
        title +
        (summary ? ':' : '') +
        '</span>' +
        (summary
          ? '<span class="sj-color-panel__summary">' + summary + '</span>'
          : '');
    } else {
      head.innerHTML =
        '<span class="sj-color-panel__title">' +
        title +
        '</span>' +
        (badge
          ? '<span class="sj-color-panel__badge">' + badge + '</span>'
          : '');
    }

    var wrap = document.createElement('div');
    wrap.className =
      'sj-option-chips sj-color-chips' +
      (compact ? ' sj-color-chips--swatches' : '') +
      (logoRow ? ' sj-color-chips--logo' : '');
    wrap.setAttribute('data-sj-sig', optionListSignature(inputs));

    inputs.forEach(function (input) {
      var value = String(input.value || '');
      var rawLabel = rawLabelForInput(input);
      var key = colorKey(value, rawLabel);
      var caption = colorSummaryText(kind, value, rawLabel);
      var price = priceHintForInput(input, kind);
      var imgUrl = swatchUrlFor(value, rawLabel);
      var hex = imgUrl ? '' : swatchHexForInput(input);
      var on = Boolean(input.checked);
      var disabled = Boolean(input.disabled);
      var choiceLabel = caption + (price ? ', ' + price : '');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'sj-option-chip sj-option-chip--color' +
        (compact ? ' sj-option-chip--swatch-only' : '');
      if (key === 'pl-silver') btn.classList.add('sj-option-chip--pl-silver');
      if (key === 'white') btn.classList.add('sj-option-chip--white-gold');
      btn.classList.toggle('is-selected', on);
      btn.disabled = disabled;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', choiceLabel);
      var swatchHtml = imgUrl
        ? '<img class="sj-option-chip__swatch-img" src="' +
          imgUrl +
          '" alt="" width="40" height="40" loading="lazy" decoding="async">'
        : '<span class="sj-option-chip__swatch" style="background-color:' +
          hex +
          '"></span>';

      if (compact) {
        // Top panel summary is the only visible label — swatches stay image-only
        btn.innerHTML = swatchHtml;
      } else {
        btn.innerHTML =
          swatchHtml +
          '<span class="sj-option-chip__text">' +
          '<span class="sj-option-chip__title">' +
          caption +
          '</span>' +
          (price
            ? '<span class="sj-option-chip__subtitle">' + price + '</span>'
            : '') +
          '</span>';
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (input.disabled) return;
        if (!input.checked) input.click();
        window.setTimeout(function () {
          refreshColorChips(field);
        }, 0);
      });
      wrap.appendChild(btn);
    });

    panel.appendChild(head);
    panel.appendChild(wrap);
    mount.innerHTML = '';
    mount.appendChild(panel);
    field.classList.add('sj-color-chips-host');
  }

  function refreshColorChips(field, force) {
    var inputs = findColorInputs(field);
    if (!inputs.length) return;
    var mount = field.querySelector('[data-sj-color-chips]');
    var wrap = mount && mount.querySelector('.sj-color-chips');
    var buttons = wrap && wrap.querySelectorAll('.sj-option-chip');
    var sig = optionListSignature(inputs);
    if (
      !force &&
      wrap &&
      buttons &&
      wrap.getAttribute('data-sj-sig') === sig &&
      buttons.length === inputs.length
    ) {
      var kind = colorFieldKind(field);
      var summary = selectedColorSummary(kind, inputs);
      var titleEl = mount.querySelector('.sj-color-panel__title');
      var summaryEl = mount.querySelector('.sj-color-panel__summary');
      var title = colorPanelTitle(kind);
      if (titleEl) titleEl.textContent = title + (summary ? ':' : '');
      if (summaryEl) summaryEl.textContent = summary;
      else if (summary) {
        renderColorChips(field);
        return;
      }
      for (var i = 0; i < buttons.length; i++) {
        var on = Boolean(inputs[i].checked);
        buttons[i].classList.toggle('is-selected', on);
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        buttons[i].disabled = Boolean(inputs[i].disabled);
      }
      return;
    }
    renderColorChips(field);
  }

  function enhanceColorField(field) {
    if (!field || field.getAttribute(COLOR_READY) === '1') return;
    if (!findColorInputs(field).length) return;

    field.setAttribute(COLOR_READY, '1');
    renderColorChips(field);

    var refresh = (window.Sj3dBuilder && window.Sj3dBuilder.rafDebounce
      ? window.Sj3dBuilder.rafDebounce
      : function (fn) { return fn; })(function () {
      refreshColorChips(field);
    });
    var mo = new MutationObserver(refresh);
    // Native swatch row only — skip `class` (Thinkspace paints it constantly).
    var nativeRow = Array.from(field.children).find(function (el) {
      return (
        el &&
        !el.hasAttribute('data-sj-color-chips') &&
        !el.classList.contains('product__label-wpper') &&
        !el.classList.contains('sj-option-chips')
      );
    });
    if (nativeRow) {
      mo.observe(nativeRow, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'disabled', 'data-value'],
      });
    }
    field.addEventListener('change', refresh, true);
    field._sjColorMo = mo;
  }

  function isColorOptionField(field) {
    var name = field.getAttribute('data-option') || '';
    if (!name) return false;
    if (name === 'Seal Color' || name === 'Logo Color') return true;
    return /^(Ring|Pendant) Color$/i.test(name);
  }

  function scan() {
    document
      .querySelectorAll('[data-option="' + METAL_OPTION + '"]')
      .forEach(enhanceMetalField);
    document.querySelectorAll('[data-option]').forEach(function (field) {
      if (isColorOptionField(field)) enhanceColorField(field);
    });
  }

  function boot() {
    var B = window.Sj3dBuilder;
    var widget =
      (B && B.widgetEl && B.widgetEl()) ||
      document.querySelector(
        'x-3d-product-options-custom-wrapper x-3d-product-options'
      ) ||
      document.querySelector('x-3d-product-options');
    if (!widget) return;

    if (B && typeof B.watchWidget === 'function') {
      B.watchWidget(widget, scan);
    } else {
      scan();
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          scan();
        });
      });
      mo.observe(widget, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
